import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  StopMarketingFlowContactPayload,
  StopMarketingFlowContactResponse
} from "../../marketing.types";
import { requestStopMarketingFlowContact } from "./stopMarketingFlowContact.request";

const useStopMarketingFlowContact = (
  options?: MutationOptions<
    StopMarketingFlowContactResponse,
    ApiServiceError<ApiError>,
    StopMarketingFlowContactPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestStopMarketingFlowContact,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useStopMarketingFlowContact;
